import { render, staticRenderFns } from "./WPButtonIcon.vue?vue&type=template&id=41b486d1"
import script from "./WPButtonIcon.vue?vue&type=script&lang=ts"
export * from "./WPButtonIcon.vue?vue&type=script&lang=ts"
import style0 from "./WPButtonIcon.vue?vue&type=style&index=0&id=41b486d1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports